<template>
  <div class="outstanding-line">
    <input type="hidden" class="outstanding-amount" :value="lineData.tmtdebdv" />
    <div class="outstanding-line-cell">
      <span>{{this.$dateformat(lineData.tdatecpt)}}</span>
    </div>
    <div class="outstanding-line-cell">
      <span>{{lineData.tdjal}}</span>
    </div>
    <div class="outstanding-line-cell">
      <span>{{lineData.tdpiece}}</span>
    </div>
    <div class="outstanding-line-cell">
      <span>{{lineData.tlib}}</span>
    </div>
    <div class="outstanding-line-cell">
      <span>{{this.$dateformat(lineData.tdateech)}}</span>
    </div>
    <div class="outstanding-line-cell">
      <span>{{lineData.tmtdebdv}}</span>
    </div>
    <div class="outstanding-line-cell">
      <span>{{lineData.tmtcredv}}</span>
    </div>
    <div class="outstanding-line-cell">
      <span>{{lineData.tdev}}</span>
    </div>
    <div class="outstanding-line-cell">
      <div class="display-flex">
        <div class="form-field">
          <input
            type="checkbox"
            class="checkbox checkbox-paiweb"
            :id="'pay_'+index"
            value="1"
            v-bind:true-value="'O'"
            v-bind:false-value="'N'"
            ref="outstanding_line"
            v-model="value_pay"
          />
          <label :for="'pay_'+index"></label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataline", "index"],
  name: "OutstandingLine",
  data() {
    return {
      lineData: {
        tdatecpt: this.$props.dataline.TDATECPT,
        tdjal: this.$props.dataline.TDJAL,
        tdpiece: this.$props.dataline.TDPIECE,
        tlib: this.$props.dataline.TLIB,
        tdateech: this.$props.dataline.TDATEECH,
        tlet: this.$props.dataline.TLET,
        tnlet: this.$props.dataline.TNLET,
        tmtdebdv: this.$props.dataline.TMTDEBDV,
        tmtcredv: this.$props.dataline.TMTCREDV,
        tdev: this.$props.dataline.TDEV,
        tpaiweb: this.$props.dataline.TPAIWEB,
        tcdev: this.$store.getters['application/get_application_customer'].TCDEV
      },
      value_pay: 'N',
    };
  },
  methods: {
    vCalculcate() {
      this.$store.dispatch('encour/SET', {key: 'outstanding_pay', value: ''});
    }
  },
  watch: {
    value_pay(val) {

      let currentValue = this.$store.getters['encour/get_outstanding_pay'];
      let currentRef = this.$store.getters['encour/get_outstanding_ref'];

      if(val === 'O') {

        this.$store.dispatch('encour/SET', {key: 'ref', value: currentRef+this.lineData.tdpiece+'#'});
        this.$store.dispatch('encour/SET', {key: 'outstanding_pay', value: Math.round(((currentValue + this.lineData.tmtdebdv - this.lineData.tmtcredv) + Number.EPSILON) * 100) / 100});

        this.$emit('currency', {selected: true, value: this.lineData.tdev});

      } else if(val === 'N') {
        this.$store.dispatch('encour/SET', {key: 'ref', value:  currentRef.replace(this.lineData.tdpiece+'#', '')});
        this.$store.dispatch('encour/SET', {key: 'outstanding_pay', value: Math.round(((currentValue - this.lineData.tmtdebdv + this.lineData.tmtcredv) + Number.EPSILON) * 100) / 100});

        this.$emit('currency', {selected: false, value: this.lineData.tdev});
      }
    }
  }
};
</script>

<style scoped>
.outstanding-line {
  display: flex;
  border: solid 1px #e9e9e9;
  margin-top: 10px;
  transition: all 0.3s;
}
.outstanding-line-cell {
  display: flex;
  width: calc(100% / 9);
  justify-content: center;
  padding: 25px 0px;
}
.outstanding-line-cell span {
  color: #585858;
  font-size: var(--fz-md);
  transition: all 0.3s;
}
.outstanding-line:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.outstanding-line:hover .outstanding-line-cell span {
  color: #8b8b8b;
}
</style>